import { Link } from 'react-router'
import { DashboardMockup } from './dashboard-mockup.tsx'

export function Hero() {
	return (
		<section
			className="relative overflow-hidden text-white"
			style={{
				background: 'var(--ink)',
				padding: '180px 0 100px',
			}}
		>
			{/* Ambient radial gradient */}
			<div
				className="pointer-events-none absolute left-1/2 top-[-20%] -translate-x-1/2"
				style={{
					width: 900,
					height: 700,
					background:
						'radial-gradient(ellipse at center, rgba(93, 47, 240, 0.28) 0%, rgba(93, 47, 240, 0) 60%)',
				}}
			/>
			<SubtleNoise />
			<HeroGrid />

			<div className="relative z-10 mx-auto max-w-[1240px] px-5 md:px-10">
				<HeroContent />
			</div>

			{/* Tilted dashboard mockup (desktop only — sidebar + main layout is not mobile-friendly) */}
			<div className="relative z-10 mx-auto mt-20 hidden max-w-[1240px] px-5 md:block md:px-10">
				<div className="rise rise-5" style={{ perspective: 2000 }}>
					<div
						style={{
							transform: 'rotateX(2deg)',
							transformOrigin: 'center top',
						}}
					>
						<DashboardMockup />
					</div>
				</div>
			</div>
		</section>
	)
}

function HeroContent() {
	return (
		<div className="mx-auto max-w-[900px] text-center">
			<div
				className="rise rise-1 mb-8 inline-flex items-center gap-2.5 rounded-full px-3.5 py-1.5 text-[12.5px]"
				style={{
					background: 'rgba(255,255,255,0.04)',
					border: '1px solid rgba(255,255,255,0.10)',
					color: 'rgba(255,255,255,0.8)',
				}}
			>
				<span
					className="size-1.5 rounded-full"
					style={{
						background: '#7B5CFF',
						boxShadow: '0 0 10px #7B5CFF',
					}}
				/>
				Veille médiatique
			</div>

			<h1 className="rise rise-2 mb-7 text-white">
				Voir clair dans le{' '}
				<span
					className="serif-italic"
					style={{ fontWeight: 300, color: '#a89dff' }}
				>
					bruit médiatique
				</span>
				.
			</h1>

			<p
				className="rise rise-3 mx-auto mb-10 max-w-155 mt-8"
				style={{
					fontSize: 19,
					lineHeight: 1.55,
					color: 'rgba(255,255,255,0.7)',
				}}
			>
				Vigilio surveille la presse québécoise et internationale pour vous. Agrégez vos sources,
				créez des alertes précises, recevez l'essentiel par courriel à la
				fréquence de votre choix.
			</p>

			<div className="rise rise-4 mb-11 flex flex-wrap justify-center gap-3">
				<Link
					to="/signup"
					className="inline-flex items-center gap-2 rounded-xl px-6 text-[15px] font-medium text-white transition-all hover:-translate-y-px"
					style={{
						height: 52,
						background: 'var(--brand)',
						boxShadow:
							'0 1px 0 rgba(255,255,255,0.15) inset, 0 8px 24px -8px var(--brand-glow)',
					}}
				>
					S'inscrire
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none">
						<path
							d="M3 7h8m0 0L7.5 3.5M11 7l-3.5 3.5"
							stroke="currentColor"
							strokeWidth="1.6"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</Link>
				<Link
					to="/contact?topic=demo"
					className="inline-flex items-center gap-2 rounded-xl px-6 text-[15px] font-medium text-white transition-colors"
					style={{
						height: 52,
						background: 'rgba(255,255,255,0.06)',
						border: '1px solid rgba(255,255,255,0.18)',
						backdropFilter: 'blur(12px)',
					}}
				>
					Demander une démo
				</Link>
			</div>

			<div
				className="rise rise-5 flex flex-wrap justify-center gap-6 text-[13px]"
				style={{ color: 'rgba(255,255,255,0.5)' }}
			>
				{[
					'Support 100% en français',
					'Conforme Loi 25 et LCAP',
					'Hébergé au Canada',
				].map((label) => (
					<span key={label} className="flex items-center gap-1.5">
						<CheckIcon />
						{label}
					</span>
				))}
			</div>
		</div>
	)
}

function CheckIcon() {
	return (
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none">
			<path
				d="M2.5 7.5L5.5 10.5L11.5 4"
				stroke="#7B5CFF"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}

function HeroGrid() {
	return (
		<div
			className="pointer-events-none absolute inset-0"
			style={{
				backgroundImage: `
					linear-gradient(to right, rgba(255,255,255,0.025) 1px, transparent 1px),
					linear-gradient(to bottom, rgba(255,255,255,0.025) 1px, transparent 1px)
				`,
				backgroundSize: '80px 80px',
				maskImage:
					'radial-gradient(ellipse at center, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 75%)',
				WebkitMaskImage:
					'radial-gradient(ellipse at center, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 75%)',
			}}
		/>
	)
}

function SubtleNoise() {
	return (
		<div
			className="pointer-events-none absolute inset-0 opacity-[0.035]"
			style={{
				mixBlendMode: 'overlay',
				backgroundImage: `url("data:image/svg+xml;utf8,<svg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>")`,
			}}
		/>
	)
}
